import axios from 'axios';

const sendPaymentUpdatedNotification = async () => axios.post('/notification/payment_updated');

export default sendPaymentUpdatedNotification;
